import GrIcon from "src/design-system/components/GrIcon";
import icons from "src/design-system/icons";
import { filterGuestSidebar, isGuestMember } from "src/utils/guestMember";

// Sidebar icons: GymRite Eva set, bundled (no runtime Iconify requests), 20px.
const getIcon = (icon) => <GrIcon icon={icon} size="lg" />;

const sidebarConfig = (navbarList, userInfo) => {
  let sidebarMenus = [];

  sidebarMenus.push({
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon(icons.dashboard),
  });

  sidebarMenus.push({
    title: "Chat",
    path: "/chat",
    icon: getIcon(icons.chat),
  });

  sidebarMenus.push({
    title: "Your Information",
    path: "/forms",
    icon: getIcon(icons.info),
    info: parseInt(userInfo?.formcount),
  });

  sidebarMenus.push({
    title: "Programmes",
    path: "/programmes",
    icon: getIcon(icons.file),
  });

  sidebarMenus.push({
    title: "Videos Library",
    path: "/videos-library",
    icon: getIcon(icons.video),
  });

  sidebarMenus.push({
    title: "Weight Tracker",
    path: "/weight-tracker",
    icon: getIcon(icons.activity),
  });

  sidebarMenus.push({
    title: "Journeys",
    path: "/trackers",
    icon: getIcon(icons.journey),
  });

  sidebarMenus.push({
    title: "calendar",
    path: "/calendar",
    icon: getIcon(icons.calendar),
  });

  sidebarMenus.push({
    title: "community feed",
    path: "/community-area",
    icon: getIcon(icons.people),
  });

  sidebarMenus.push({
    title: "Helping videos",
    path: "/helping_videos_category",
    icon: getIcon(icons.play),
  });

  if (navbarList && navbarList?.booking_enable) {
    sidebarMenus.push({
      title: navbarList?.nav_title,
      path: "/redirect-page",
      icon: getIcon(icons.clock),
    });
  }

  sidebarMenus.push({
    title: "Support Ticket",
    path: "/support-ticket",
    icon: getIcon(icons.support),
  });

  // Journey guests (magic-link login) only see Dashboard + Journeys.
  if (isGuestMember(userInfo)) return filterGuestSidebar(sidebarMenus);

  return sidebarMenus;
};
export default sidebarConfig;
